import { useMyEventUser } from '@api/services'

export const usePurchaseAmountMode = (eventId: number) => {
  const eventUser = useMyEventUser(eventId)

  return eventUser.data?.purchase_amount_mode ?? 'user-enters-total-cost'
}
